var map = {
	"./add-user.svg": "5119",
	"./alert-warn.svg": "fb30",
	"./alert.svg": "1540",
	"./arrow-right-solid.svg": "6d0b",
	"./arrows/down-angle.svg": "3a9a",
	"./arrows/left-angle.svg": "c21a",
	"./arrows/left-arrow.svg": "6c72",
	"./arrows/right-angle.svg": "8e9e",
	"./arrows/right-arrow.svg": "d613",
	"./broken_link.svg": "2dca",
	"./btnactionicon.svg": "7d87",
	"./bvnwarn.svg": "8c8f",
	"./cancelcriteria.svg": "5e4c",
	"./changePasswordicon.svg": "2cd5",
	"./changeProfilepixicon.svg": "a154",
	"./check-list 1.svg": "e23b",
	"./close.svg": "0572",
	"./cloud_upload.svg": "bdd1",
	"./criteriacheck.svg": "ccc8",
	"./customer-support.svg": "4d5b",
	"./dashboard.svg": "a2db",
	"./document-attachment 1.svg": "fde4",
	"./eye-off.svg": "bb6f",
	"./eye-on.svg": "b24c",
	"./file.svg": "6b64",
	"./gg_check-o.svg": "a0a3",
	"./gps.svg": "46da",
	"./headphone.svg": "d007",
	"./ic_outline-cancel.svg": "fb302",
	"./info_dash.svg": "d0f6",
	"./jpeg.svg": "bb33",
	"./list.svg": "a93e",
	"./logout.svg": "c5d0",
	"./map_add.svg": "87cc",
	"./menu.svg": "39c4",
	"./no_user.svg": "b646",
	"./pdf.svg": "59d6",
	"./print.svg": "9fbb",
	"./profile.svg": "e40e",
	"./quill_info.svg": "efa6",
	"./search.svg": "f919",
	"./settings.svg": "e15e",
	"./shield-fail.svg": "eb72",
	"./shield.svg": "8231",
	"./support.svg": "7f1f",
	"./symbols_download.svg": "4eaa",
	"./task-done-02 1.svg": "d77a",
	"./uil_print.svg": "a2a7",
	"./user-add-icon.svg": "f6e4",
	"./user-id-fail.svg": "da0d",
	"./user-id-pass.svg": "1bc8",
	"./verified.svg": "5df3",
	"./wallet.svg": "1113"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";